import React from "react";
import useTranslation from "../hooks/useTranslation";
import { Link } from "react-router-dom";

const Pagination = ({ pagination, currentUri }) => {
  const { t } = useTranslation();
  const { page, pages } = pagination;

  const prevUri = currentUri.clone().setSearch({ page: page - 1 });
  const nextUri = currentUri.clone().setSearch({ page: page + 1 });

  return (<div className="pagination">
      <div className="navigator">
        <p className="pageCount">
          {t("page")} {page} {t("of")} {pages}
        </p>
        {page > 1 && (
          <Link to={prevUri.toString()} className="previous">
            <span className="paginationWords">{t("previous")}</span>
          </Link>
        )}
        {page < pages && (
          <Link to={nextUri.toString()} className="next">
            <span className="paginationWords">{t("next")}</span>
          </Link>
        )}
      </div>
    <span />
  </div>);
};

export default Pagination;
